import { createFileRoute } from '@tanstack/react-router'

import HighlightsIndex from './-components'

export const Route = createFileRoute('/_authenticated/$alias/settings/highlights/')({
  component: HighlightsIndex,
})
